const isPomodoroNotificationSupported = () =>
  typeof window !== 'undefined' && 'Notification' in window

const getPomodoroNotificationIcon = () => {
  if (typeof window === 'undefined') {
    return ''
  }

  return `${window.location.origin}/logotipo tcc.ico`
}

const focusPomodoroRoute = () => {
  window.focus()

  if (window.location.pathname !== '/') {
    window.history.pushState({}, '', '/')
    window.dispatchEvent(new PopStateEvent('popstate'))
  }
}

const requestPomodoroNotificationPermission = async () => {
  if (!isPomodoroNotificationSupported()) {
    return 'unsupported'
  }

  if (window.Notification.permission === 'granted') {
    return 'granted'
  }

  if (window.Notification.permission === 'denied') {
    return 'denied'
  }

  try {
    return await window.Notification.requestPermission()
  } catch (e) {
    return 'denied'
  }
}

const sendPomodoroNotification = async ({ title, body }) => {
  const permission = await requestPomodoroNotificationPermission()

  if (permission !== 'granted') {
    return false
  }

  try {
    const icon = getPomodoroNotificationIcon()
    const notification = new window.Notification(title, {
      body,
      icon,
      badge: icon,
      tag: 'to-focus-pomodoro',
      renotify: true,
    })

    notification.onclick = () => {
      try {
        focusPomodoroRoute()
      } catch (e) {
        window.open(
          `${window.location.origin}/`,
          '_blank',
          'noopener,noreferrer'
        )
      } finally {
        notification.close()
      }
    }

    return true
  } catch (e) {
    return false
  }
}

export {
  isPomodoroNotificationSupported,
  requestPomodoroNotificationPermission,
  sendPomodoroNotification,
}
